// src/components/Login.jsx
import React, { useState } from 'react';
import { apiFetch } from '../api';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    try {
      // actually await & use apiFetch
      const res = await apiFetch('login.php', {
        method: 'POST',
        body: JSON.stringify({ username, password })
      });
      const js = await res.json();
      if (res.ok && js.user_id) {
        onLogin();  // bubble success back to App.js
      } else {
        setError(js.error || 'Login fehlgeschlagen');
      }
    } catch (err) {
      setError('Server nicht erreichbar');
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        <h2>Admin Login</h2>
        {error && <p className="error">{error}</p>}
        <label>
          Benutzer:
          <input
            value={username}
            onChange={e => setUsername(e.target.value)}
            required
          />
        </label>
        <label>
          Passwort:
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
        </label>
        <button type="submit">Einloggen</button>
      </form>
    </div>
  );
}
